import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import Select from "react-select";
import { useFormik } from "formik";
// import axios from "axios";
import OtpInput from "react-otp-input";
// import Cookies from "js-cookie";
// import { ToastContainer, toast } from 'react-toastify';
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import * as Yup from "yup";
// import { adminMainUrl } from "../../../Config";
// import { adminLoginSchema } from "../../../ValidationScema";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { adminMainUrl } from "../../Config";
// import { toast } from 'react-toastify';
// import Api from "../../../Api";
const Otp = () => {
    const location = useLocation();
    // const notify = () => toast("Wow so easy!");
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [otp, setOtp] = useState("");
    //   const [showPassword, setShowPassword] = useState(true);
    //   const [roleId, setRoleId] = useState([]);
    const [mail, setMail] = useState(null);
    useEffect(() => {
        if (location.state?.email) {
            setMail(location.state.email);
        }
        if (location.state?.otp) {
            // toast.success(location.state.otp);
        }
    }, [location.state]);

    const formik = useFormik({
        initialValues: {
            otp: "",
        },
        onSubmit: async () => {
            setIsSubmitting(true);
            try {
                const response = await fetch(`${adminMainUrl}/api/forgot-otp-verify`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": localStorage.getItem("auth-token"), // Add auth-token if required
                    },
                    body: JSON.stringify({
                        email: mail, // Pre-filled email
                        otp: otp, // OTP entered by the user
                    }),
                });
                const data = await response.json();
                if (response.ok) {
                    toast.success(data?.msg);
                      navigate("/change-password", { state: { email: mail } }); // Redirect to the next step
                } else {
                    toast.error(data?.msg);
                    const errorData = await response.json();
                    console.error("Error verifying OTP:", errorData.message);
                }
            } catch (error) {
                console.error("Network error:", error);
            } finally {
                setIsSubmitting(false); // Stop the spinner
            }
        },
    });

    return (
        <div className="account-page">
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-03">
                        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
                            <form
                                className="flex-fill"
                                onSubmit={formik.handleSubmit}
                            >
                                <div className="mx-auto mw-450">
                                    <div className="text-center mb-4">
                                        <img src="/assets/img/logo.png" className="img-fluid" alt="Logo" />
                                    </div>
                                    {/* <div className="mb-4">
                                        <h4 className="mb-2 fs-20">Forgot Password?</h4>
                                        <p>
                                            If you forgot your password, well, then we’ll email you
                                            instructions to reset your password.
                                        </p>
                                    </div> */}
                                    <div className="mb-3">
                                        <label className="col-form-label">Enter OTP</label>
                                        {/* <div className="position-relative">
                                            <span className="input-icon-addon">
                                                <i className="ti ti-mail" />
                                            </span> */}
                                        <div className="form-outline otp-input mb-2">

                                            <OtpInput
                                                value={otp}
                                                onChange={setOtp}
                                                numInputs={4}
                                                renderSeparator={<span>-</span>}
                                                renderInput={(props) => <input {...props} />}
                                            />
                                        </div>
                                        {/* </div> */}
                                        {/* {formik.touched.email && formik.errors.email ? (
                                            <div className="error">{formik.errors.email}</div>
                                        ) : null} */}
                                    </div>
                                    <div className="mb-3">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? (
                                                <i className="fa fa-spinner fa-spin" />
                                            ) : (
                                                "Submit"
                                            )}
                                        </button>

                                    </div>
                                    {/* <div className="mb-3 text-center">
                                        <h6>
                                            Return to
                                            <Link to="/login" className="text-purple link-hover">
                                                Login
                                            </Link>
                                        </h6>
                                    </div> */}
                                    {/* <div className="form-set-login or-text mb-3">
                                <h4>OR</h4>
                            </div>
                            <div className="d-flex align-items-center justify-content-center flex-wrap mb-3">
                                <div className="text-center me-2 flex-fill">
                                    <a
                                        href="javascript:void(0);"
                                        className="br-10 p-2 px-4 btn bg-pending  d-flex align-items-center justify-content-center"
                                    >
                                        <img
                                            className="img-fluid m-1"
                                            src="assets/img/icons/facebook-logo.svg"
                                            alt="Facebook"
                                        />
                                    </a>
                                </div>
                                <div className="text-center me-2 flex-fill">
                                    <a
                                        href="javascript:void(0);"
                                        className="br-10 p-2 px-4 btn bg-white d-flex align-items-center justify-content-center"
                                    >
                                        <img
                                            className="img-fluid  m-1"
                                            src="assets/img/icons/google-logo.svg"
                                            alt="Facebook"
                                        />
                                    </a>
                                </div>
                                <div className="text-center flex-fill">
                                    <a
                                        href="javascript:void(0);"
                                        className="bg-dark br-10 p-2 px-4 btn btn-dark d-flex align-items-center justify-content-center"
                                    >
                                        <img
                                            className="img-fluid  m-1"
                                            src="assets/img/icons/apple-logo.svg"
                                            alt="Apple"
                                        />
                                    </a>
                                </div>
                            </div> */}
                                    <div className="text-center">
                                        <p className="fw-medium text-gray">Copyright © 2024 - CRMS</p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Otp